// Pushes the GTM 'contactFormSubmit' event when a page renders an
// Umbraco Forms submission confirmation.
//
// The flex theme's Submitted.cshtml outputs a .js-umbraco-form-submit marker
// (with form name/id data attributes) after a successful PRG submission —
// this partial is the consumer that turns it into a dataLayer event. The
// event name matches the GTM trigger "[Custom Event] Umbraco Form Submission",
// whose custom-event filter is {{_event}} equals "contactFormSubmit".
//
// The marker only renders on the request immediately following a submission
// (Umbraco Forms TempData), so refreshes don't re-fire the event.
document.querySelectorAll('.js-umbraco-form-submit').forEach(function (el) {
    if (el.dataset.dlTracked) return;
    el.dataset.dlTracked = 'true';

    if (typeof window.pushDataLayer === 'function') {
        window.pushDataLayer('contactFormSubmit', {
            form_name: el.dataset.formName || '',
            form_id: el.dataset.formId || '',
            record_id: el.dataset.recordId || ''
        });
    }
});
